export const skills = {
    frontend: ['HMTL', 'CSS', 'SASS', 'JS', 'jQuery', 'React'],
    backend: ['PHP', 'MySQL', 'Node.js', 'Express', 'MongoDB'],
    other: ['APIs', 'WordPress', 'Responsive Design', 'SEO', 'Problem Solving'],
    tools: ['Visual Studio', 'GitHub', 'Penpot & XD']
};